import { forTemplate } from 'app/common/lib/util/i18n';
import { AlertContainer } from 'app/gamma/src/components/alert';
import {
  SaveMessages,
  PROFILE_ALERT_AREA,
} from 'app/gamma/src/modules/state/ui/member-home-profile';
import React from 'react';
import { ComponentWrapper } from 'app/src/components/ComponentWrapper';

const format = forTemplate('member_detail_profile_edit');

export const MemberProfileAlerts: React.FunctionComponent = () => {
  return (
    <ComponentWrapper>
      <AlertContainer
        displayType="info"
        name={SaveMessages.SAVING}
        area={PROFILE_ALERT_AREA}
        msTimeout={3000}
      >
        {format(SaveMessages.SAVING)}
      </AlertContainer>
      <AlertContainer
        displayType="info"
        name={SaveMessages.SAVED}
        area={PROFILE_ALERT_AREA}
        msTimeout={3000}
      >
        {format(SaveMessages.SAVED)}
      </AlertContainer>
    </ComponentWrapper>
  );
};
